$amalitech-font: 'Work Sans', sans serif;
$breadcrumb-size: 1rem !default;
$breadcrumb-separator-default: '>' !default;

$breadcrumb-sizes: (
  'large': $size-7,
  'medium': $size-6,
  'small': $size-5,
) !default;

$breadcrumb-separators: (
  'slash': '\0002f',
  'dot': '\2022',
  'arrow': '>',
) !default;

// ***  Main  ***

:host(.is-breadcrumb) {
  display: flex;
  font-size: var(--breadcrumbSize, $breadcrumb-size);
  font-family: var(--breadcrumbFont, $amalitech-font);
  padding: 0;
  align-items: flex-start;
  flex-wrap: wrap;
}

// ***  Item  ***

// Item: Align
@each $name, $value in ('center': 'center', 'right': 'flex-end') {
  :host(.is-#{$name}) {
    justify-content: #{$value};
  }
}

// Item: Separators
::slotted(amalitech-breadcrumb-item:nth-child(n + 2))::before {
  color: $neutral-400;
  content: $breadcrumb-separator-default;
  margin: 0 1rem;
}

@each $name, $value in $breadcrumb-separators {
  :host(.has-separator-#{$name}) > ::slotted(amalitech-breadcrumb-item:nth-child(n + 2))::before {
    content: '#{$value}';
  }
}

// Item: Sizes
@each $name, $value in $breadcrumb-sizes {
  :host(.is-#{$name}) {
    font-size: #{$value};
  }
}
